<template>
  <div>
    <div class="content">
      <div class="title">
        <span>肠内营养服务</span>
      </div>
      <ul>
        <li>
          <span>医院：</span>
          <span>长春中医药大学附属第三临床医院</span>
        </li>
      </ul>
      <div>
        <div class="totalContent">
          <p class="title">订单金额</p>
          <p style="display: flex; align-items: center;">
            <span style="width: 20px;font-size: 22px;">¥</span>
            <van-field @blur="uptadeNumber(money)" style="width: 70%;font-size: 22px;" v-model="money" type="number" :maxlength="9"
                       minlength="1" placeholder="请输入订单金额" />
          </p>
        </div>
        <div class="btnContent">
          <van-button @click="payment" round size="small" type="success">
            立即支付
          </van-button>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import {
} from "@/api/prescription/prescription";
import { reactive, toRefs } from "vue";
import {
  generateMoneySubmit
} from "@/api/prescription/prescription";
import { Toast } from "vant";

export default {
  mounted() {

  },
  methods: {
  },
  setup() {
    const state = reactive({
      category: "code",
      money: null
    });

    // 支付方法
    const payment = () => {
      const param = {
        code: '41271789622010411A2101',
        money: state.money
      }
      if (!param.money) {
        Toast("请输入金额");
        return;
      }
      generateMoneySubmit(param).then((v) => {
        const { data } = v
        window.location.href = data;
      }).catch((error) => {
        console.log(error);
      });
    };
    const uptadeNumber = (val) => {
      if (val !== '' && val.substr(0, 1) === '.') {
        val = "";
      }
      val = val.replace(/^0*(0\.|[1-9])/, '$1');//解决 粘贴不生效
      val = val.replace(/[^\d.]/g, "");  //清除“数字”和“.”以外的字符
      val = val.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
      val = val.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
      if (val.indexOf('.') < 0 && val != '') {
        //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        val = parseFloat(val)
      }
      state.money = parseFloat(val).toFixed(2);
    }

    return {
      ...toRefs(state),
      payment,
      uptadeNumber
    };
  },
};
</script>
<style lang="scss" scoped>
.content {
  border: 1px solid var(--basic-border-color);
  border-top: none;

  .totalContent {
    .title {
      opacity: 0.5;
    }

    p:last-of-type {
      background: var(--basic-price);
      padding: 16px;
      // background: ;
      text-align: left;

      span {
        font-size: 17px;
        display: inline-block;
        width: 32%;
      }
    }
  }

  .title {
    height: 40px;
    padding-left: 10px;
    line-height: 40px;
    border-bottom: 1px solid var(--basic-border-color);

    span {
      padding: 2px 10px;
      border-radius: 10px;
      color: #fff;
      font-size: 12px;
      background: var(--basic-green);
    }
  }

  ul {
    li {
      padding: 16px;
      border-bottom: 1px solid var(--basic-border-color);

      span:first-of-type {
        color: var(--basic-labe);
      }

      div {
        p {
          display: inline-block;
          width: 48%;
        }

        p:last-of-type {
          border: none;
          padding-left: 10px;
        }
      }
    }
  }
}

.btnContent {
  padding: 20px 20px 0 20px;
  text-align: center;

  button {
    width: 50%;
    display: block;
    margin: 0 auto;
    margin-bottom: 10px;
  }
}

.seeInfoContent {
  padding: 10px 20px 20px 20px;
  text-align: center;

  button {
    width: 50%;
    display: block;
    margin: 0 auto;
    margin-bottom: 10px;
  }
}
</style>
